import dataProvider from "src/dataProvider";

let fetcher = dataProvider("addressInstance");

export const getAddress = async (pinCode: string) => {
  return fetcher.get(`/${pinCode}`, {}, "");
};
